import React, { useEffect, useRef } from 'react';
import { PropTypes } from 'prop-types';
import { Button, Field } from '@ontruck/orc';

const EditField = ({
  onChange,
  id,
  labelField,
  value,
  help,
  submitLabel,
  submitAction,
  cancelLabel,
  cancelAction,
}) => {
  const fieldRef = useRef(null);

  useEffect(() => {
    document.getElementById(id)?.focus();
  }, [id]);

  return (
    <div className="form" data-testid="edit-field">
      <Field
        id={id}
        focused={true}
        ref={fieldRef}
        name={id}
        onChange={onChange}
        label={labelField}
        type="text"
        fullWidth
        value={value}
      />
      {help}
      <Button onClick={submitAction} text={submitLabel} />
      <Button onClick={cancelAction} text={cancelLabel} nude skin="secondary" />
    </div>
  );
};

EditField.propTypes = {
  onChange: PropTypes.func,
  id: PropTypes.string,
  labelField: PropTypes.string,
  value: PropTypes.string,
  help: PropTypes.element,
  submitLabel: PropTypes.string,
  submitAction: PropTypes.func,
  cancelLabel: PropTypes.string,
  cancelAction: PropTypes.func,
};

EditField.defaultProps = {
  onChange: () => ({}),
  id: '',
  labelField: '',
  value: '',
  help: '',
  submitLabel: '',
  submitAction: () => ({}),
  cancelLabel: '',
  cancelAction: () => ({}),
};

export default EditField;
